import { useEffect } from "react";
import { COMPANY } from "@/data/site";

const canonicalPath = (p) => (p === "/" || /\/$/.test(p) || !/-brest$/.test(p) ? p : `${p}/`);

export default function usePageMeta(title, description) {
  useEffect(() => {
    document.title = title ? `${title} | Conciergerie Familly 29` : "Conciergerie à Brest – votre logement entre de bonnes mains | Conciergerie Familly 29";
    if (description) {
      document.querySelector('meta[name="description"]')?.setAttribute("content", description);
      document.querySelector('meta[property="og:description"]')?.setAttribute("content", description);
    }
    const url = `${COMPANY.site}${canonicalPath(window.location.pathname)}`;
    document.querySelector('link[rel="canonical"]')?.setAttribute("href", url);
    document.querySelector('meta[property="og:url"]')?.setAttribute("content", url);
    document.querySelector('meta[property="og:title"]')?.setAttribute("content", document.title);
  }, [title, description]);
}
